import { NOTIFICATION } from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case NOTIFICATION:
      if(action.notification && (action.notification.type === "bookevent")) {
        return {
          ...state,
          notification:action.notification
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/bookevent.js